import getThemeOptions from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'toggleThemeQuickOptionExpansion',
    function toggleThemeQuickOptionExpansion(overrideValue?: boolean) {
        let themeOptions = getThemeOptions();
        themeOptions.isQuickOptionExpanded =
            overrideValue === void 0 ? !themeOptions.isQuickOptionExpanded : overrideValue;
    }
);
